import React, { type ComponentType } from "react";
import { Navigate } from "react-router-dom";
import { Spin } from "antd";
import { useAppSelector } from "../store/hooks";
import { APP_ROUTES } from "../utils/appRoutes";

type ProtectedRouteProps = {
  component: ComponentType;
};

const ProtectedRoute = ({ component: Component }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading } = useAppSelector((state) => state.auth);

  if (isLoading) {
    return (
      <div
        className="flex min-h-[40vh] items-center justify-center"
        data-testid="protected-route-loading"
      >
        <Spin size="large" tip="Loading..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={APP_ROUTES.home} replace />;
  }

  return <Component />;
};

export default ProtectedRoute;
